import {useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import useSWR from "swr";
import useAsyncErrorHandler from "./useAsyncErrorHandler";
import useLoading from "./useLoading";
import {fetch} from "../features/async";

export default function useSWRFetch(url, params, config = {}, credencial, returnInnerLoadingState = false) {
    const setLoading = useLoading();
    const [innerLoading, setInnerLoading] = useState(false);
    const credencialRedux = useSelector(state => state.credencial);

    /*
     * A credencial fica fora da chave do SWR: o back a renova a cada resposta e, na chave,
     * cada renovação viraria uma nova busca (laço de requisições). Vai a mais recente na hora da chamada.
     */
    const credencialAtual = useRef();
    credencialAtual.current = credencial || credencialRedux;

    const { data, isLoading, error, isValidating } = useSWR(
        [url, params],
        ([urlChave, paramsChave]) => fetch(urlChave, credencialAtual.current, paramsChave),
        {
            onError: useAsyncErrorHandler(),
            ...config
        });

    useEffect(() => {
        const loadingState = isLoading || isValidating;

        returnInnerLoadingState
            ? setInnerLoading(loadingState)
            : setLoading(loadingState);
    }, [isLoading, isValidating]);

    const loading = returnInnerLoadingState ? innerLoading : isLoading || isValidating;

    return returnInnerLoadingState ? { data, loading } : data;
}
